import authentication from '@feathersjs/authentication-client';
import rest from '@feathersjs/rest-client';
import { createClient } from 'backend/client';

const isDev = process.env.NODE_ENV === 'development';
const BASE_URL = 'http://localhost:3030';
const restBaseClient = rest(BASE_URL);
const restClient = isDev ? restBaseClient : rest();

// Configure the browser fetch library
export const client =
  typeof window === 'undefined'
    ? createClient(restBaseClient.fetch(fetch))
    : createClient(restClient.fetch(window.fetch.bind(window)) as any);
client.configure(authentication({ path: 'api/authentication' }) as any);
